"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.History = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Payable(_a) {
    var billing = _a.billing;
    return react_1.default.createElement(storybook_1.Buttons.Link, { to: billing.payment, className: 'text-blue-600' }, "Nu betalen");
}
function Paid(_a) {
    var billing = _a.billing;
    return react_1.default.createElement("a", { href: billing.download, target: '_blank', className: 'text-blue-600' }, "PDF");
}
function Orderable(_a) {
    var billing = _a.billing;
    var _b = ra_fetch_1.useApi('ecommerce').update('billings.order', { id: billing.id, channel_id: billing.channel_id }), billingOrder = _b[0], setBillingOrder = _b[1], submitBillingOrder = _b[2];
    return react_1.default.createElement(storybook_1.Forms.Buttons, { errors: billingOrder.errors, loading: billingOrder.submitting },
        react_1.default.createElement(storybook_1.Buttons.Button, { className: 'text-blue-600', disabled: billingOrder.submitting, onClick: function () { return submitBillingOrder().then(function (response) {
                if (!response.errors.length) {
                    window.location.href = response.data.payment;
                }
            }); } }, "Nu betalen"));
}
var actions = {
    orderable: Orderable,
    payable: Payable,
    paid: Paid
};
function History(_a) {
    var channel = _a.channel, billings = _a.billings;
    return react_1.default.createElement("div", { className: 'rounded bg-white mb-sm' },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'pt-sm pl-sm' }, "Historie"),
        react_1.default.createElement(storybook_1.Billings.Divider, null),
        react_1.default.createElement("div", { className: 'px-sm pb-md' },
            react_1.default.createElement("div", { className: 'grid grid-cols-12' },
                react_1.default.createElement("div", { className: 'col-span-3 text-gray-500' }, "DATUM"),
                react_1.default.createElement("div", { className: 'col-span-5 text-gray-500' }, "OMSCHRIJVING"),
                react_1.default.createElement("div", { className: 'col-span-3 text-gray-500' }, "BEDRAG"),
                react_1.default.createElement("div", { className: 'col-span-1 text-right' })),
            react_1.default.createElement(storybook_1.Billings.Divider, null),
            billings.map(function (billing, index) {
                var status = billing.status;
                if (!channel.billing_from || channel.billing_from > billing.invoice_date.en) {
                    status = 'paid';
                }
                var Action = actions[status];
                return react_1.default.createElement("div", { key: index },
                    react_1.default.createElement("div", { className: 'grid grid-cols-12' },
                        react_1.default.createElement("div", { className: 'col-span-3' }, billing.invoice_date.nl),
                        react_1.default.createElement("div", { className: 'col-span-5 text-gray-500' },
                            channel.label,
                            " \u2022 ",
                            billing.description),
                        react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('col-span-2', billing.negative ? 'text-primary' : 'text-gray-500'), dangerouslySetInnerHTML: { __html: billing.prices.total } }),
                        react_1.default.createElement("div", { className: 'storybook-billings-history-action' },
                            react_1.default.createElement(Action, { billing: billing }))),
                    index !== billings.length - 1 &&
                        react_1.default.createElement(storybook_1.Billings.Divider, null));
            })));
}
exports.History = History;
